module.exports = __webpack_public_path__ + "static/Ginger.c68ddc0c.png";